import { useQuery } from "react-query";
import { http } from "src/api/http";
import FansCampaignPerformancePresenter from "./FansCampaignPerformancePresenter";

export default function FansCampaignPerformanceContainer() {
  const { data, isLoading, isError } = useQuery<any>({
    queryKey: ["fans-campaign-performance"],
    queryFn: () => http("/api/my-fans/campaigns/performance"),
  });

  return (
    <FansCampaignPerformancePresenter
      loading={isLoading}
      error={isError}
      data={data}
    />
  );
}
